<template>
  <div>
    <chart-card
      :chart-data="barchart.data"
      :chart-options="barchart.options"
      :chart-responsive-options="barchart.responsiveOptions"
      chart-type="Bar"
      :render="render">
      <template slot="header">
        <h4 class="card-title">Evolution over time</h4>
        <p class="card-category">{{subtitle}}</p>
      </template>
      <template slot="footer">
        <div class="legend">
          <i class="fas fa-circle ct-legend-a"></i> Received &nbsp;
          <i class="fas fa-circle ct-legend-b"></i> Closed &nbsp;
          <span> <strong><b>%</b></strong> Close Rate </span>
        </div>
        <hr>
        <div class="stats">
          2019-01 &nbsp; <i class="fas fa-arrow-alt-right"/> &nbsp; 2019-12
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Leads-Graph-Single-View-Card',
  components: {
    ChartCard
  },
  props: { 
    barchart: { type: Object, required: true },
    render: { type: Boolean, default: false }
  },
  computed: {
    subtitle () {
      if (this.$store.getters.periodSelected) {
        return this.$store.getters.periodSelected.label
      }
      return ''
    }
  }
}
</script>

<style>

</style>